module.exports = __webpack_public_path__ + "static/media/vibepure-4.0f342c85.jpg";